import { clsx } from 'clsx';

export interface PlaceholderProps {
  /** Upper-case token, e.g. `YEARS_IN_BUSINESS` → renders `{{YEARS_IN_BUSINESS}}`. */
  token: string;
  className?: string;
}

/**
 * A fact only the owner can supply (a year, a certification number, an address). It is shown as a
 * visibly marked `{{TOKEN}}` — never as an invented value — and every token used anywhere must be
 * listed in `docs/CONTENT_TODO.md`. Search the code for `{{` (or `data-placeholder`) to find them all.
 */
export function Placeholder({ token, className }: PlaceholderProps) {
  return (
    <span className={clsx('placeholder', className)} data-placeholder="true">
      {`{{${token}}}`}
    </span>
  );
}
